export default {
  "groupNameIsRequired": "Group name is required",
  "defaultQuotaMustBeAWholeNumberBetween1And": "Default quota must be a whole number between 1 and 10000 GB",
  "missingSecurityTokenPleaseRefreshThePage": "Missing security token. Please refresh the page.",
  "failedToSaveGroup": "Failed to save group",
  "groupCreated": "Group created",
  "groupUpdated": "Group updated",
  "createGroup": "Create Group",
  "editGroup": "Edit Group",
  "createANewUserGroupWithAppAccessPermissions": "Create a new user group with app access permissions.",
  "close": "Close",
  "groupName": "Group Name",
  "eGArrPower": "e.g., *arr Power",
  "description": "Description",
  "optionalDescription": "Optional description...",
  "assetManagementCenter": "Asset Management Center",
  "mediaPermissionCatalogUnavailable": "Media permission catalog unavailable.",
  "defaultStorageQuotaGB": "Default storage quota (GB)",
  "noGroupDefault": "No group default",
  "clearGroupQuotaDefault": "Clear group quota default",
  "usersInheritTheHighestQuotaAmongTheirGroupsExplicitPer": "Users inherit the highest quota among their groups. Explicit per-user overrides set in User Admin take precedence.",
  "appAccess": "App Access",
  "cancel": "Cancel",
  "saveChanges": "Save Changes",
  "failedToLoadUsers": "Failed to load users",
  "missingSecurityToken": "Missing security token",
  "failedToAddUser": "Failed to add user",
  "userAddedToGroup": "User added to group",
  "cannotRemoveAdminUsersFromAdministratorGroup": "Cannot remove admin users from Administrator group",
  "removeUserFromGroup": "Remove user from group",
  "failedToRemoveUser": "Failed to remove user",
  "userRemovedFromGroup": "User removed from group",
  "manageGroupUsers": "Manage group users",
  "searchUsers": "Search users...",
  "currentMembers": "Current Members",
  "addUsers": "Add Users",
  "noUsersFoundMatchingYourSearch": "No users found matching your search",
  "noUsersAvailable": "No users available",
  "locked": "Locked",
  "onlySuperAdminsCanBeAssignedToThisRole": "Only super admins can be assigned to this role",
  "changeUserRole": "Change user role",
  "failedToAssignUser": "Failed to assign user",
  "cannotRemoveSuperAdminsFromTheirRole": "Cannot remove super admins from their role",
  "removeUserFromRole": "Remove user from role",
  "userRemovedFromRole": "User removed from role",
  "manageRoleUsers": "Manage role users",
  "usersCanOnlyHaveOneRoleAssigningMovesThemFrom": "Users can only have one role. Assigning moves them from their current role.",
  "assignUsers": "Assign Users",
  "onlySuperAdminsCanBeAssigned": "Only super admins can be assigned",
  "super": "Super",
  "admin": "Admin",
  "loadingApps": "Loading apps...",
  "noApplicationsInstalled": "No applications installed",
  "serviceFailed": "Service failed",
  "serviceRunning": "Service running",
  "serviceStopped": "Service stopped",
  "libraryAccess": "Library access",
  "shareLinks": "Share links",
  "emailShares": "Email shares",
  "ruTorrentPlugins": "ruTorrent plugins",
  "deleteProtection": "Delete protection",
  "superAdministratorsAlwaysRetainThisCapability": "Super administrators always retain this capability",
  "administratorsAlwaysHaveFullMediaAccess": "Administrators always have full media access",
  "inherit": "Inherit",
  "allow": "Allow",
  "deny": "Deny",
  "quotaMustBeAWholeNumberBetween1And10000": "Quota must be a whole number between 1 and 10000 GB",
  "mediaQuotaOverrideSet": "Media quota override set",
  "failedToUpdateQuota": "Failed to update quota",
  "quotaOverrideClearedRevertedToInheritedValue": "Quota override cleared — reverted to inherited value",
  "failedToResetQuota": "Failed to reset quota",
  "overrideCleared": "Override cleared",
  "permissionUpdated": "Permission updated",
  "failedToUpdatePermission": "Failed to update permission",
  "loadingMediaAccess": "Loading media access...",
  "retry": "Retry",
  "storageQuota": "Storage quota",
  "used": "Used",
  "setOverride": "Set override",
  "mediaStorageQuotaOverrideInGB": "Media storage quota override in GB",
  "saveMediaQuotaOverride": "Save media quota override",
  "clearTheOverrideAndRevertToTheInheritedGroupInstance": "Clear the override and revert to the inherited group/instance default",
  "resetQuotaToInherited": "Reset quota to inherited",
  "appManagement": "App Management",
  "superAdminProtected": "Super Admin — protected",
  "approve": "Approve",
  "impersonate": "Impersonate",
  "viewDetails": "View Details",
  "collapseDetails": "Collapse details",
  "searchUsers2": "Search users",
  "filterByStatus": "Filter by status",
  "allStatus": "All Status",
  "active": "Active",
  "banned": "Banned",
  "awaiting": "Awaiting",
  "refresh": "Refresh",
  "addUser": "Add User",
  "noUsersFound": "No users found",
  "tryAdjustingYourSearchOrFilters": "Try adjusting your search or filters",
  "dataUnavailable": "Data unavailable",
  "criticalLessThan5Free": "Critical: less than 5% free",
  "loadingMetrics": "Loading metrics...",
  "unableToLoadMetrics": "Unable to load metrics",
  "memory": "Memory",
  "quotasAreNotInstalledThisUserHasUnrestrictedDiskAccess": "Quotas are not installed. This user has unrestricted disk access. Enable quotas to set per-user limits.",
  "disk": "Disk",
  "noQuota": "No quota",
  "configEditing": "Config Editing",
  "allowUsersToEditApplicationConfigurationFilesDirectlyFromThe": "Allow users to edit application configuration files directly from the dashboard.",
  "mountInformation": "Mount Information",
  "displayDiskMountAndStorageInformationOnUserDashboards": "Display disk mount and storage information on user dashboards.",
  "autoBackupOnInstall": "Auto-Backup on Install",
  "automaticallyCreateABackupOfApplicationDataBeforeInstallingUpdates": "Automatically create a backup of application data before installing updates.",
  "settingUpdated": "Setting updated",
  "failedToSaveSetting": "Failed to save setting",
  "pleaseTryAgain": "Please try again.",
  "emailUpdated": "Email updated",
  "failedToUpdateEmail": "Failed to update email",
  "invalidShellLevel": "Invalid shell level",
  "shellLevelUpdated": "Shell level updated",
  "failedToUpdateShellLevel": "Failed to update shell level",
  "quotaCannotBeEmpty": "Quota cannot be empty",
  "quotaUpdated": "Quota updated",
  "account": "Account",
  "email": "Email",
  "shell": "Shell",
  "quota": "Quota",
  "eG500GBOr4TB": "e.g., 500GB or 4TB",
  "userID": "User ID",
  "created": "Created",
  "lastLogin": "Last Login",
  "lastIP": "Last IP",
  "2FADisabledForThisUser": "2FA disabled for this user",
  "failedToDisable2FA": "Failed to disable 2FA",
  "passkeysDeletedForThisUser": "Passkeys deleted for this user",
  "failedToDeletePasskeys": "Failed to delete passkeys",
  "security": "Security",
  "disable2FAForThisUserRecoveryAction": "Disable 2FA for this user (recovery action)",
  "disable2FA": "Disable 2FA",
  "passkeys": "Passkeys",
  "deleteAllPasskeysForThisUserRecoveryAction": "Delete all passkeys for this user (recovery action)",
  "deletePasskeys": "Delete passkeys",
  "sessions": "Sessions",
  "installedApps": "Installed Apps",
  "resetPassword": "Reset Password",
  "changeRole": "Change Role",
  "promoteToAdmin": "Promote to Admin",
  "revokeSessions": "Revoke Sessions",
  "unban": "Unban",
  "ban": "Ban",
  "delete": "Delete",
  "thisAccountIsAwaitingApproval": "This account is awaiting approval.",
  "loadingUserDetails": "Loading user details...",
  "failedToLoadUserDetails": "Failed to load user details",
  "groups": "Groups",
  "none": "None",
  "roles": "Roles",
  "applications": "Applications",
  "loading": "Loading...",
  "justNow": "just now",
  "user": "User",
  "role": "Role",
  "status": "Status",
  "banUser": "Ban User",
  "reasonOptional": "Reason (optional)",
  "enterReasonForBan": "Enter reason for ban...",
  "createUser": "Create User",
  "createANewUserAccountTheUserWillBeAssigned": "Create a new user account. The user will be assigned the standard role by default.",
  "username": "Username",
  "336CharactersLowercase": "3-36 characters, lowercase",
  "password": "Password",
  "minimum5Characters": "Minimum 5 characters",
  "hidePassword": "Hide password",
  "showPassword": "Show password",
  "group": "Group",
  "selectAGroup": "Select a group...",
  "eG500GBOr2TB": "e.g., 500GB or 2TB",
  "deleteUser": "Delete User",
  "newPassword": "New Password",
  "passwordMustBeAtLeast5Characters": "Password must be at least 5 characters",
  "superAdmin": "Super Admin",
  "standardUser": "Standard User",
  "normalUserAccess": "Normal user access",
  "fullAdministrativeAccess": "Full administrative access",
  "networkError": "Network error",
  "failedToLoadMediaPermissions": "Failed to load media permissions",
  "failedToLoadStorageQuota": "Failed to load storage quota",
  "failedToLoadMediaAccess": "Failed to load media access",
  "failedToClearOverride": "Failed to clear override",
  "viewUserListAndDetails": "View user list and details",
  "createNewUsers": "Create new users",
  "modifyUserAccounts": "Modify user accounts",
  "removeUserAccounts": "Remove user accounts",
  "impersonateOtherUsers": "Impersonate other users",
  "viewRoles": "View roles",
  "createEditDeleteRoles": "Create, edit, delete roles",
  "viewGroups": "View groups",
  "createEditDeleteGroups": "Create, edit, delete groups",
  "viewSystemSettings": "View system settings",
  "modifySystemSettings": "Modify system settings",
  "modifyInstanceBrandingLogosFaviconDefaultAvatarBanner": "Modify instance branding (logos, favicon, default avatar/banner)",
  "viewAllUserSessions": "View all user sessions",
  "revokeUserSessions": "Revoke user sessions",
  "accessSystemDashboard": "Access system dashboard",
  "viewSystemLogs": "View system logs",
  "accessWebConsole": "Access web console",
  "manageDatabase": "Manage database",
  "manageSSLCertificates": "Manage SSL certificates",
  "manageVPNSettings": "Manage VPN settings",
  "performSystemUpdates": "Perform system updates",
  "manageAPISettings": "Manage API settings",
  "enableOrDisableSupportTeamAccess": "Enable or disable support team access",
  "viewExternalLinks": "View external links",
  "manageExternalLinks": "Manage external links",
  "installSoftware": "Install software",
  "removeSoftware": "Remove software",
  "configureSoftware": "Configure software",
  "viewAppConfigurationFiles": "View app configuration files",
  "editAppConfigurationFiles": "Edit app configuration files",
  "createAppBackupsConfigNginxFull": "Create app backups (config, nginx, full)",
  "restoreAppBackups": "Restore app backups",
  "deleteAppBackups": "Delete app backups",
  "browseAppSQLiteDatabaseFiles": "Browse app SQLite database files",
  "viewStreamingDashboard": "View streaming dashboard",
  "manageStreamingSettings": "Manage streaming settings",
  "viewMediaRequests": "View media requests",
  "approveOrDenyMediaRequests": "Approve or deny media requests",
  "manageLargeFileDeleteProtectionViewStatusEnableDisableServer": "Manage large-file-delete protection (view status, enable/disable server-wide)",
  "mediaManagement": "Media Management",
  "appsForOrganizingAndManagingMediaLibraries": "Apps for organizing and managing media libraries",
  "mediaServers": "Media Servers",
  "appsForStreamingAndServingMediaContent": "Apps for streaming and serving media content",
  "mediaRequests": "Media Requests",
  "appsForManagingMediaRequests": "Apps for managing media requests",
  "downloadClients": "Download Clients",
  "torrentAndNZBDownloadClients": "Torrent and NZB download clients",
  "indexersTrackers": "Indexers & Trackers",
  "appsForFindingContentSources": "Apps for finding content sources",
  "automationTools": "Automation & Tools",
  "appsForAutomatingMediaWorkflows": "Apps for automating media workflows",
  "fileManagement": "File Management",
  "appsForManagingAndSyncingFiles": "Apps for managing and syncing files",
  "eBooksComics": "E-Books & Comics",
  "appsForReadingDigitalContent": "Apps for reading digital content",
  "remoteAccess": "Remote Access",
  "appsForRemoteSystemAccess": "Apps for remote system access",
  "communication": "Communication",
  "iRCAndChatApplications": "IRC and chat applications",
  "utilitiesSystem": "Utilities & System",
  "systemUtilitiesAndSecurityTools": "System utilities and security tools",
  "youDonTHavePermissionToViewUserSettings": "You don't have permission to view user settings.",
  "failedToLoadUserSettings": "Failed to load user settings",
  "failedToUpdateUserSettings": "Failed to update user settings",
  "featureToggles": "Feature Toggles",
  "failedToApproveUser": "Failed to approve user",
  "failedToUnbanUser": "Failed to unban user",
  "failedToRevokeSessions": "Failed to revoke sessions",
  "failedToImpersonateUser": "Failed to impersonate user",
  "failedToBanUser": "Failed to ban user",
  "failedToDeleteUser": "Failed to delete user",
  "failedToResetPassword": "Failed to reset password",
  "failedToChangeRole": "Failed to change role",
  "failedToCreateUser": "Failed to create user",
  "userManagement": "User Management",
  "manageAccountsRolesAndAccess": "Manage accounts, roles, and access.",
  "failedToFetchGroups": "Failed to fetch groups",
  "failedToLoadGroups": "Failed to load groups",
  "failedToSetDefaultGroup": "Failed to set default group",
  "all": "All",
  "system": "System",
  "custom": "Custom",
  "hasUsers": "Has Users",
  "hasApps": "Has Apps",
  "empty": "Empty",
  "usersAssigned": "Users Assigned",
  "appAssignments": "App Assignments",
  "cannotDeleteSystemGroups": "Cannot delete system groups",
  "deleteGroup": "Delete group",
  "failedToDeleteGroup": "Failed to delete group",
  "groupDeleted": "Group deleted",
  "name": "Name",
  "default": "Default",
  "media": "Media",
  "defaultMediaStorageQuotaForThisGroup": "Default media storage quota for this group",
  "apps": "Apps",
  "users": "Users",
  "setAsDefaultGroup": "Set as default group",
  "setAsDefault": "Set as default",
  "editGroup2": "Edit group",
  "edit": "Edit",
  "userGroups": "User Groups",
  "manageApplicationAccessGroupsGroupsControlWhichAppsUsersCan": "Manage application access groups. Groups control which apps users can access.",
  "searchGroupsAppsUsers": "Search groups, apps, users...",
  "noGroupsFoundCreateYourFirstGroupToControlApp": "No groups found. Create your first group to control app access.",
  "groupManagement": "Group Management",
  "roleManagement": "Role Management",
  "softwareManagement": "Software Management",
  "systemAdministration": "System Administration",
  "settings": "Settings",
  "sessionManagement": "Session Management",
  "externalLinks": "External Links",
  "streaming": "Streaming",
  "failedToFetchRoles": "Failed to fetch roles",
  "failedToLoadRoles": "Failed to load roles",
  "power": "Power",
  "standard": "Standard",
  "basic": "Basic",
  "avgCoverage": "Avg Coverage",
  "roleIDIsRequired": "Role ID is required",
  "roleNameIsRequired": "Role name is required",
  "roleIDMustBeLowercaseAlphanumericWithUnderscoresEG": "Role ID must be lowercase alphanumeric with underscores (e.g., power_user)",
  "failedToSaveRole": "Failed to save role",
  "roleCreated": "Role created",
  "roleUpdated": "Role updated",
  "theSuperAdminRoleCannotBeDeleted": "The Super Admin role cannot be deleted",
  "onlyASuperAdminCanDeleteSystemRoles": "Only a Super Admin can delete system roles",
  "deleteRole": "Delete role",
  "failedToDeleteRole": "Failed to delete role",
  "roleDeleted": "Role deleted",
  "iD": "ID",
  "priority": "Priority",
  "permissions": "Permissions",
  "allPermissions": "All permissions",
  "onlyASuperAdminCanEditSystemRoles": "Only a Super Admin can edit system roles",
  "editRole": "Edit role",
  "createRole": "Create Role",
  "userRoles": "User Roles",
  "manageAdminRolesRolesGrantAdministrativePermissionsToDashboardFeatures": "Manage admin roles. Roles grant administrative permissions to dashboard features.",
  "searchRolesPermissionsUsers": "Search roles, permissions, users...",
  "noRolesFoundCreateYourFirstRoleToGrantAdmin": "No roles found. Create your first role to grant admin permissions.",
  "editRole2": "Edit Role",
  "createANewAdminRoleWithSpecificPermissions": "Create a new admin role with specific permissions.",
  "onlyASuperAdminCanEditSystemRoles2": "Only a Super Admin can edit system roles.",
  "roleID": "Role ID",
  "eGPowerUser": "e.g., power_user",
  "uniqueIdentifierLowercaseUnderscoresAllowed": "Unique identifier (lowercase, underscores allowed)",
  "displayName": "Display Name",
  "eGPowerUser2": "e.g., Power User",
  "higherPriorityMoreAdministrativeAuthority1100": "Higher priority = more administrative authority (1-100)",
  "clearAll": "Clear all",
  "selectAll": "Select all",
  "editingValue": "Editing \"{{name}}\"",
  "areYouSureYouWantToRemoveValueFromValue": "Are you sure you want to remove \"{{username}}\" from \"{{groupName}}\"? This may affect their app access.",
  "removeValue": "Remove {{username}}",
  "addValue": "Add {{username}}",
  "valueAlreadyHasARoleAssignedAssigningToValueWill": "\"{{username}}\" already has a role assigned. Assigning to \"{{roleName}}\" will remove them from their current role. Continue?",
  "valueAssignedToValue": "{{username}} assigned to {{roleName}}",
  "areYouSureYouWantToRemoveValueFromValue2": "Are you sure you want to remove \"{{username}}\" from \"{{roleName}}\"? They will lose any admin permissions granted by this role.",
  "assignValue": "Assign {{username}}",
  "restartValue": "Restart {{label}}",
  "stopValue": "Stop {{label}}",
  "startValue": "Start {{label}}",
  "overrideValueGB": "Override: {{gb}} GB",
  "defaultValueGB": "Default: {{gb}} GB",
  "groupValue": "group: {{groupName}}",
  "accessForValue": "Access for {{value1}}",
  "approveValue": "Approve {{username}}",
  "impersonateValue": "Impersonate {{username}}",
  "viewDetailsForValue": "View details for {{username}}",
  "savingValue": "Saving {{label}}...",
  "saveValue": "Save {{label}}",
  "savingValue2": "Saving {{label}}",
  "levelValue": "Level {{userLevel}}",
  "errorValue": "Error ({{status}})",
  "failedToLoadUsersValue": "Failed to load users ({{status}})",
  "valueHasBeenApproved": "{{username}} has been approved",
  "valueHasBeenUnbanned": "{{username}} has been unbanned",
  "sessionsRevokedForValue": "Sessions revoked for {{username}}",
  "impersonatingValue": "Impersonating {{username}}",
  "valueHasBeenBanned": "{{username}} has been banned",
  "valueHasBeenDeleted": "{{username}} has been deleted",
  "passwordResetForValue": "Password reset for {{username}}",
  "roleUpdatedForValue": "Role updated for {{username}}",
  "userValueCreated": "User {{username}} created",
  "valueIsNowTheDefaultGroup": "\"{{name}}\" is now the default group",
  "areYouSureYouWantToDeleteValueUsersIn": "Are you sure you want to delete \"{{name}}\"? Users in this group will lose their app access.",
  "areYouSureYouWantToDeleteValueUsersWith": "Are you sure you want to delete \"{{name}}\"? Users with this role will lose their admin permissions.",
  "viewingValueReadOnly": "Viewing \"{{name}}\" (read-only)",
  "overrideUsers_one": "{{formattedCount}} user currently has an explicit override.",
  "overrideUsers_other": "{{formattedCount}} users currently have an explicit override.",
  "appsSelected_one": "{{formattedCount}} app selected",
  "appsSelected_other": "{{formattedCount}} apps selected",
  "appsCount_one": "{{formattedCount}} app",
  "appsCount_other": "{{formattedCount}} apps",
  "categoryApps_one": "({{formattedCount}} app)",
  "categoryApps_other": "({{formattedCount}} apps)",
  "members_one": "{{name}} • {{formattedCount}} member",
  "members_other": "{{name}} • {{formattedCount}} members",
  "moreUsers_one": "+{{formattedCount}} more user (use search to narrow)",
  "moreUsers_other": "+{{formattedCount}} more users (use search to narrow)",
  "inheritedQuota": "Inherited: {{gb}} GB",
  "inheritedGroupQuota": "Inherited: {{gb}} GB (group: {{groupName}})",
  "quotaUsage": "{{used}} GB of {{max}} GB ({{percent}}%)",
  "configAccessHelp": "Per-app config access can be customized in {{link}}",
  "appTemplates": "App Templates",
  "banConfirm": "Ban {{username}}? This will revoke all sessions and restrict their access.",
  "deleteWarning": "This action is {{irreversible}}. All user data, sessions, and associated records will be permanently removed.",
  "irreversible": "irreversible",
  "deleteConfirm": "Type {{username}} to confirm",
  "passwordConfirm": "Set a new password for {{username}}. All other sessions will be revoked.",
  "roleConfirm": "Change the role for {{username}}.",
  "optionalQuota": "Disk Quota (optional)",
  "permissionSelection": "{{selected}} / {{total}} selected",
  "usersShown_one": "{{shown}} of {{formattedCount}} user",
  "usersShown_other": "{{shown}} of {{formattedCount}} users",
  "usersCount_one": "{{formattedCount}} user",
  "usersCount_other": "{{formattedCount}} users",
  "processes_one": "{{formattedCount}} process",
  "processes_other": "{{formattedCount}} processes",
  "filterItems_one": "Filter by {{label}}: {{formattedCount}} item",
  "filterItems_other": "Filter by {{label}}: {{formattedCount}} items",
  "override": "Override",
  "assign": "Assign",
  "remove": "Remove",
  "actions": "Actions",
  "granted": "Granted",
  "denied": "Denied",
  "save": "Save",
  "reset": "Reset",
  "enabled": "Enabled",
  "disabled": "Disabled",
  "configured": "Configured",
  "collapse": "Collapse",
  "inactive": "Inactive",
  "failed": "Failed",
  "viewPassword": "View password",
  "viewPasswordForValue": "View password for {{username}}",
  "revealPassword": "Reveal password",
  "passwordRevealIntro": "Show the stored password for {{username}}. Each reveal is recorded in the audit log.",
  "storedPassword": "Stored password",
  "passwordRevealInvalidUsername": "This username cannot have a stored password.",
  "passwordRevealMissing": "No stored password is on record for this account.",
  "passwordRevealRateLimited": "Too many password reveals. Wait a moment, then try again.",
  "passwordRevealUnreadable": "The stored password record exists but the dashboard could not read it.",
  "passwordRevealUndecryptable": "The stored password record is damaged or cannot be decrypted with this server's key.",
  "passwordRevealAuditUnavailable": "The password was not shown because the audit record could not be written. Try again, and check the audit log if this keeps happening."
} as const;
